import { useState } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import CallsDetails from "./CallsDetails";

const TABS = ["Calls", "SMS"];

// Placeholder until each tab's layout is defined
const Placeholder = (props: { label: string }) => (
  <Box sx={{ mt: 2, p: 4, textAlign: "center", border: "1px dashed #ccc" }}>
    <Typography variant="h6">{props.label}</Typography>
    <Typography variant="body2" color="text.secondary">
      Coming soon.
    </Typography>
  </Box>
);

const DailySummary = (props: ChildProps) => {
  const [tab, setTab] = useState<number>(0);

  return (
    <Box sx={{ mt: 2 }}>
      <Tabs value={tab} onChange={(_, value) => setTab(value)} sx={{ borderBottom: 1, borderColor: "divider" }}>
        {TABS.map((label) => (
          <Tab key={label} label={label} />
        ))}
      </Tabs>
      {tab === 0 ? <CallsDetails projectId={props.projectId} dateStart={props.dateStart} dateEnd={props.dateEnd} /> : <Placeholder label="SMS" />}
    </Box>
  );
};

interface ChildProps {
  projectId: string;
  dateStart: Date;
  dateEnd: Date;
}

export default DailySummary;
